import { appConfig } from 'config/environment/appConfig'

import { HttpService } from 'services/HttpService'
import convertKeysToCamelCase from 'utils/helpers/convertKeysToCamelCase'

import { IChatMessageDTO } from './types'

const searchEngineV2HttpService = new HttpService(appConfig.SEARCH_ENGINE_URL)

export class searchEngineV2Api {
  static async sendClientMessage(message: string): Promise<Partial<IChatMessageDTO>> {
    const request = await searchEngineV2HttpService.post<Partial<IChatMessageDTO>>('bert-api/v2/send-message-promo', {
      body: {
        request: message,
      },
    })
    return convertKeysToCamelCase(request)
  }
}
